import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: "1px solid black",
  [`&.MuiTableCell-head`]: {
    color: theme.palette.text.primary,
    borderRight: "1px solid black",
    fontSize: 20,
    lineHeight: 1.5,
    fontWeight: "bolder",
  },
  [`&.MuiTableCell-body`]: {
    fontSize: 14,
    borderRight: "1px solid black",
  },
  "&.MuiTableCell-sr": {
    borderBottom: "none",
    textAlign: "center",
    verticalAlign: "middle",
    height: "10px",
    color: theme.palette.text.primary,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  // "&:nth-of-type(odd)": {
  //   backgroundColor: theme.palette.action.hover
  // }
}));

// function createData(
//   description,
//   unresolvedBegin,
//   newCases,
//   closedCases,
//   unresolvedEnd
// ) {
//   return { description, unresolvedBegin, newCases, closedCases, unresolvedEnd };
// }

// const rows = [
//   "Misrepresentation of Facts", "-", "-"),
//   createData("Total"),
// ];

const colData = [
  { id: 1, label: "Unresolved cases at the beginning of Q4 FY 22" },
  { id: 2, label: "New Cases during Q4 FY 22" },
  { id: 3, label: "Cases Closed during Q4 FY 22" },
  { id: 4, label: "Unresolved cases at the end of Q4 FY 22" },
];
const rowlabel = [
  { id: 1, label: "Sr. No." },
  { id: 2, label: "Description of fraud" },
  { id: 3, label: "No." },
  { id: 4, label: "Amount involved." },
  { id: 5, label: "No." },
  { id: 6, label: "Amount involved." },
  { id: 5, label: "No." },
  { id: 6, label: "Amount involved." },
  { id: 5, label: "No." },
  { id: 6, label: "Amount involved." },
];

const StandardColLabel = [
  { id: 1, label: "Sr. No." },
  { id: 2, label: "Description of fraud" },
  { id: 3, label: "No. of Cases" },
  { id: 4, label: "Amount involved." },
];

export default function CustomizedTabel({ rowData, variant, StandardRowData }) {
  return variant === "Standard" ? (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 0,
        width: "90%",
        marginTop: "3rem",
        marginLeft: "auto",
        marginRight: "auto",
        background: "white",
      }}
    >
      <Table
        sx={{ minWidth: 700 }}
        aria-label="customized table"
        className="FMR"
      >
        <TableHead className="FMR">
          <TableRow>
            {StandardColLabel.map((item, index) => (
              <StyledTableCell key={item?.id}>{item?.label}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {StandardRowData.map((row, index) => (
            <StyledTableRow>
              <StyledTableCell>
                {row.description === "Total" ? null : index + 1}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell>{}</StyledTableCell>
              <StyledTableCell>{}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  ) : (
    <TableContainer
      component={Paper}
      sx={{
        borderRadius: 0,
        width: "90%",
        marginTop: "3rem",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Table
        sx={{ minWidth: 700 }}
        aria-label="customized table"
        className="FMR"
      >
        <TableHead className="FMR">
          <TableRow>
            <StyledTableCell className="MuiTableCell-sr"></StyledTableCell>
            <StyledTableCell className="MuiTableCell-sr"></StyledTableCell>
            {colData.map((item, index) => (
              <StyledTableCell colSpan={2} key={item?.id}>
                {item?.label}
              </StyledTableCell>
            ))}
          </TableRow>
          <TableRow>
            {rowlabel?.map((item, index) => (
              <StyledTableCell>{item?.label}</StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData.map((row, index) => (
            <StyledTableRow key={index}>
              <StyledTableCell>
                {row.description === "Total" ? null : index + 1}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell>{row.unresolvedBegin}</StyledTableCell>
              <StyledTableCell>{row.unresolvedBegin}</StyledTableCell>
              <StyledTableCell>{row.newCases}</StyledTableCell>
              <StyledTableCell>{row.newCases}</StyledTableCell>
              <StyledTableCell>{row.closedCases}</StyledTableCell>
              <StyledTableCell>{row.closedCases}</StyledTableCell>
              <StyledTableCell>{row.unresolvedEnd}</StyledTableCell>
              <StyledTableCell>{row.unresolvedEnd}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
